<style scoped lang="scss">

</style>

<template>
<div class="uk-grid">
  <div class="uk-width-1-1 uk-margin-top">
    <validated-section :errors="errors" field="organization.organization_name">
      <label for="name">{{ __('tenant.company_name') }}<span class="uk-text-danger uk-text-bold">*</span> :</label>
      <text-input name="Landlord Company Name" v-model="form.company_name" :placeholder="__('tenant.company_name')"></text-input>
    </validated-section>
  </div>
  <div class="uk-width-1-2 uk-margin-top">
    <validated-section :errors="errors" field="person.first_name">
      <label for="name">{{ __('tenant.landlord_first_name') }}<span class="uk-text-danger uk-text-bold">*</span> :</label>
      <text-input name="First Name" v-model="form.first_name" :placeholder="__('tenant.first_name')"></text-input>
    </validated-section>
  </div>
  <div class="uk-width-1-2 uk-margin-top">
    <validated-section :errors="errors" field="person.last_name">

      <label for="name">{{ __('tenant.landlord_last_name') }}<span class="uk-text-danger uk-text-bold">*</span> :</label>
      <text-input name="Last Name" v-model="form.last_name" :placeholder="__('tenant.last_name')"></text-input>
    </validated-section>
  </div>

  <div class="uk-width-1-2 uk-margin-top">
    <validated-section :errors="errors" field="person.email" >
      <label for="name">{{ __('tenant.landlord_email') }}<span class="uk-text-danger uk-text-bold">*</span> :</label>
      <text-input name="Email Address" v-model="form.email" :placeholder="__('tenant.enter_email_address')" type="email"></text-input>
    </validated-section>
  </div>
  <div class="uk-width-1-2 uk-margin-top">
    <validated-section :errors="errors" field="person.phone">
      <label for="name">{{ __('tenant.landlord_phone_number') }}</label>
      <phone-number-input
          name="Phone"
          v-model="form.phone"
          @onInputChange="onPhoneChanged"
          :placeholder="__('tenant.enter_phone_number')">
      </phone-number-input>
    </validated-section>
  </div>

  <div class="uk-width-1-1 uk-margin-top">
    <validated-section :errors="errors" field="organization.address.name">
      <label for="name">{{ roleName }}  Property Name:</label>
      <text-input name="PropertyName"  v-model="form.property_name" :placeholder="__('tenant.enter_property_name')"/>
    </validated-section>
  </div>

  <div class="uk-width-1-2 uk-margin-top">
    <validated-section :errors="errors" field="organization.address.address_1">
      <label for="name">{{ roleName }}  {{ __('global.address_1') }}:</label>
      <text-input name="Address1"  v-model="form.address_1" :placeholder="__('tenant.enter_address_line_1')"/>
    </validated-section>
  </div>
  <div class="uk-width-1-2 uk-margin-top">
    <validated-section :errors="errors" field="organization.address.address_2">
      <label for="name">{{ roleName }} {{ __('global.address_2') }}:</label>
      <text-input name="Address2" v-model="form.address_2" :placeholder="__('tenant.enter_address_line_2')"/>
    </validated-section>
  </div>
  <div class="uk-width-1-2 uk-margin-top">
    <validated-section :errors="errors" field="organization.address.city">
      <label for="name">{{ roleName }} {{ __('global.city') }}:</label>
      <text-input name="City" v-model="form.city" :placeholder="__('global.city')"/>
    </validated-section>
  </div>
  <div class="uk-width-1-2 uk-margin-top">
    <validated-section :errors="errors" field="organization.address.state_id">
      <label for="role">{{ roleName }} {{ __('global.state') }} : <br></label>
      <select v-model="form.state_id" class="uk-width-1-1 uk-form-large">
        <option v-for="state in states" :value="state.id" :selected="form.state_id === state.id">
          {{ state.name }}
        </option>
      </select>
    </validated-section>
  </div>
  <div class="uk-width-1-2 uk-margin-top">
    <validated-section :errors="errors" field="organization.address.zip">
      <label for="name">{{ roleName }}  {{ __('global.zip') }} :</label> <br>
      <text-input name="Zip" v-model="form.zip" id="zip" :placeholder="__('global.zip')"/>
    </validated-section>
  </div>
</div>
</template>

<script>
import {mapState} from "vuex";
import ValidatedSection from "../../Common/ValidatedSection";

export default {
  name: "TenantLandlordForm",
  components: {ValidatedSection},
  data() {
    return {
      form: {},
      errors: {},
      states: [
        { id: '', name: 'Select State'},
        { id: 1, name: 'Alabama'},
        { id: 2, name: 'Alaska'},
        { id: 3, name: 'Arizona'},
        { id: 4, name: 'Arkansas'},
        { id: 5, name: 'California'},
        { id: 6, name: 'Colorado'},
        { id: 7, name: 'Connecticut'},
        { id: 8, name: 'Delaware'},
        { id: 9, name: 'District of Columbia'},
        { id: 10, name: 'Florida'},
        { id: 11, name: 'Georgia'},
        { id: 12, name: 'Hawaii'},
        { id: 13, name: 'Idaho'},
        { id: 14, name: 'Illinois'},
        { id: 15, name: 'Indiana'},
        { id: 16, name: 'Iowa'},
        { id: 17, name: 'Kansas'},
        { id: 18, name: 'Kentucky'},
        { id: 19, name: 'Louisiana'},
        { id: 20, name: 'Maine'},
        { id: 21, name: 'Maryland'},
        { id: 22, name: 'Massachusetts'},
        { id: 23, name: 'Michigan'},
        { id: 24, name: 'Minnesota'},
        { id: 25, name: 'Mississippi'},
        { id: 26, name: '1'},
        { id: 27, name: 'Montana'},
        { id: 28, name: 'Nebraska'},
        { id: 29, name: 'Nevada'},
        { id: 30, name: 'New Hampshire'},
        { id: 31, name: 'New Jersey'},
        { id: 32, name: 'New Mexico'},
        { id: 33, name: 'New York'},
        { id: 34, name: 'North Carolina'},
        { id: 35, name: 'North Dakota'},
        { id: 36, name: 'Ohio'},
        { id: 37, name: 'Oklahoma'},
        { id: 38, name: 'Oregon'},
        { id: 39, name: 'Pennsylvania'},
        { id: 40, name: 'Rhode Island'},
        { id: 41, name: 'South Carolina'},
        { id: 42, name: 'South Dakota'},
        { id: 43, name: 'Tennessee'},
        { id: 44, name: 'Texas'},
        { id: 45, name: 'Utah'},
        { id: 46, name: 'Vermont'},
        { id: 47, name: 'Virginia'},
        { id: 48, name: 'Washington'},
        { id: 49, name: 'West Virginia'},
        { id: 50, name: 'Wisconsin'},
        { id: 51, name: 'Wyoming'},
        { id: 52, name: 'England (Country)'},
        { id: 53, name: 'Manitoba (Canada)'},
      ],
    }
  },
  computed: {
    ...mapState('Application', {
      householdApplicationLandlord: state => state.householdApplicationLandlord,
    })
  },
  watch: {
    householdApplicationLandlord(newValue) {
      if (newValue)
      {
        this.form = newValue;
      }
    }
  },
  mounted() {
    if(this.householdApplicationLandlord) {
      this.initForm();
    }
  },
  methods: {
    initForm() {
      this.form = this.householdApplicationLandlord;
    },
    getForm() {
      return this.form;
    },
    async validate() {
      this.errors = {};
      if(!this.form.company_name && !this.form.first_name) {
        this.$set(this.errors, 'organization.organization_name', { errors: ['You must enter a company name if you do not have a contact first name.']});
        this.$set(this.errors, 'person.first_name', { errors: ['You must enter a contact first name if you do not have a company name.']});
      }

      if(!this.form.email && !this.form.phone) {
        this.$set(this.errors, 'person.email', { errors: ['You must enter a contact email if you do not enter a phone number.']});
        this.$set(this.errors, 'person.phone', { errors: ['You must enter a contact phone number if you do not enter a email.']});
      }

      return this.errors;
    }
  }
}
</script>
